import { render, staticRenderFns } from "./SystemLogo.vue?vue&type=template&id=45af6f26"
import script from "./SystemLogo.vue?vue&type=script&lang=js"
export * from "./SystemLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports